import { render, staticRenderFns } from "./ProductPricingModal.vue?vue&type=template&id=5fe1f5cc&"
import script from "./ProductPricingModal.vue?vue&type=script&lang=js&"
export * from "./ProductPricingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports